import { render } from "./AgeLegal.vue?vue&type=template&id=3c8980bc&scoped=true"
import script from "./AgeLegal.vue?vue&type=script&lang=js"
export * from "./AgeLegal.vue?vue&type=script&lang=js"

import "./AgeLegal.vue?vue&type=style&index=0&id=3c8980bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8980bc"]])

export default __exports__